<form #fiscalYearForm="ngForm">
  <ng-select [items]="fiscalYear$ | async" bindLabel="title" bindValue="id"
             placeholder="กรุณาเลือก" [searchable]="true" [ngModel]="fiscalYearId" [clearable]="clearable" (change)="selectFiscalYear($event)"
             [disabled]="disabled"
             #fiscalYear="ngModel"
             name="fiscalYear"
             [required]="required"
              [ngClass]="{'is-invalid': fiscalYear.touched && required}">
  </ng-select>
</form>
